export const questions = [
  '¿Con qué frecuencia sientes el corazón acelerado sin razón?',
  '¿Te cuesta trabajo apagar la mente para dormir?',
  '¿Sientes tensión en el cuello, hombros o mandíbula?',
  '¿Te preocupas por cosas que probablemente no pasarán?',
  '¿Sientes que debes poder con todo sin pedir ayuda?',
  '¿Has tenido sensación de ahogo o falta de aire sin causa física?',
  '¿Te sientes irritable o al límite sin saber por qué?',
  '¿Evitas situaciones sociales por miedo a sentirte mal?',
  '¿Sientes que tu ansiedad afecta tu familia o pareja?',
  '¿Has pensado que necesitas ayuda pero no has actuado aún?',
]

export const options = [
  { label: 'Casi nunca', points: 1 },
  { label: 'A veces', points: 2 },
  { label: 'Frecuentemente', points: 3 },
  { label: 'Casi todos los días', points: 4 },
]
